var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.patientData)?_c('v-tab-item',{attrs:{"value":"rechnungen"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('RechnungenDatatable')],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }